export default __webpack_public_path__ + "static/media/ad_preview_display_bot.8191d37b.svg";